module.exports = __webpack_public_path__ + "media/images/index/step1-d26104c6003e27ce838d6a5b3617c467.svg";